import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import ActivityManager from "@/activity/ActivityManager";
import SessionManager from "@/utils/SessionManager";
import Perms, {setDynamicPermissionsForReports} from "@/server/Perms";
import {parseIconName} from "@/FontAwesomeSetup";
import FormsLoader from "@/components/forms/FormsLoader";
import CompanyConfigurationsFormsLoader from "@/components/forms/CompanyConfigurationFormsLoader";
import CompanyConfigurationFormsLoader from "@/components/forms/CompanyConfigurationFormsLoader";
import Log from "@/utils/Log";
import FormsActions from "@/components/forms/FormsActions";
import BookHealthcheck from "@/server/com/silkplm/model/healthcheck/BookHealthcheck";
import assignProducts from "@/components/forms/customizations/plm/ProductToSeason";
import {listCompanyConfiguration} from "@/server/com/silkplm/model/plm/CompanyConfiguration";
import {
    checkIfEnabledByFeatureFlags,
    checkIfEnabledByOrganizationFormsSettingsForForm,
    findFieldValueFromCompanyCompanyConfigurationForm,
    removeLeftMenuItemsWhenHasNoItems,
} from "@/components/forms/customizations/plm/EntityEditFormService";
import Rpc from "@/Rpc";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import {MODULE_LOGISTIC_OP, MODULE_PLM, SUPPLIERS_PANEL} from "@/utils/Modules";
import getDashletHome from "@/components/dashboard/GlobalDashlet";
import InstructionsAndSupport from "@/components/InstructionsAndSupport/InstructionsAndSupport.vue";
import tr from "@/utils/Tr";
import PantoneActivity from "@/components/tools/pantone/PantoneActivity.vue";
import AIProductGenerator from "@/components/tools/AIPhotoGenerator/AIProductGenerator.vue";
import {listGS1} from "@/server/com/silkplm/model/plm/GS1";
import {listPrestaShop} from "@/server/com/silkplm/model/plm/PrestaShop";
import {openSubscriptionPanel} from "@/components/subscriptions/Subs";
import Inspiration from "@/server/com/silkplm/model/plm/Inspiration";
import * as EntityEditFormService from "@/components/forms/customizations/plm/EntityEditFormService";

const Reports = () => require("@/components/plm/Reports.vue");


const UserEditPanel = () => require("@/components/forms/customizations/plm/UserEditPanel");
const UserNotificationsPanel = () => require("@/components/notifications/UserNotificationsPanel");
const OrganizationSetup = () => require("@/components/organization/OrganizationSetupActivity");
const DataImport = () => require("@/components/forms/DataImport");
const DataExport = () => require("@/components/forms/DataExport");
const BrandingParameters = () => require("@/components/plm/BrandingParameters");

let LEFT_MENU = () => [
    {
        id: 'shipment',
        label: $tr("shipment", "Shipment"),
        modules: {MODULE_LOGISTIC_OP},
        icon: 'sliders-v-square',
        open: false,
        items: [],
    },
    {
        id: 'plm',
        label: $tr("productLifecycle", "Product Lifecycle"),
        icon: "tshirt",
        open: false,
        modules: {MODULE_PLM},
        items: [
            {
                id: 'reportsTab',
                enabledByFeatureFlag: FeatureFlag.REPORTS,
                label: $tr("reports", "Reports"),
                menuOrder: 100000,
                modules: {MODULE_PLM},
                icon: "folder-grid",
                action: async () => {
                    return ActivityManager.showActivity(Reports, {}, null, true);
                },
            },
            {
                id: 'eans-group',
                label: "EAN's",
                modules: {MODULE_PLM},
                icon: "sliders-simple",
                items: [],
                menuOrder: 1000,
            },
        ]
    },

    {
        id: 'contacts',
        label: tr("contractors", "Contractors"),
        modules: {MODULE_LOGISTIC_OP, MODULE_PLM, SUPPLIERS_PANEL},
        icon: 'address-book',
        open: false,
        items: []
    },

    {
        id: 'suppliersPanel',
        label: tr("inquiries", "Inquiries"),
        enabledByFeatureFlag: FeatureFlag.SUPPLIERS_MARKET,
        modules: {SUPPLIERS_PANEL},
        icon: 'fa-regular fa-message',
        open: true,
        items: []
    },

    // {
    //     id: 'suppliersDictionaries',
    //     label: tr("dictionaries", "Dictionaries"),
    //     modules: {SUPPLIERS_PANEL},
    //     icon: 'fa-regular fa-coins',
    //     open: true,
    //     items: []
    // },

    {
        id: 'logistics',
        label: $tr("logistics", "Logistics"),
        icon: "truck",
        open: true,
        modules: {MODULE_PLM},
        items: []
    },

    {
        id: 'dict',
        label: $tr("dictionaries", "Dictionaries"),
        icon: "books",
        modules: {MODULE_LOGISTIC_OP, MODULE_PLM},
        open: false,
        items: [
            {
                id: 'dict-administration',
                label: $tr("administration", "Administration"),
                icon: "books",
                open: false,
                modules: {MODULE_PLM},
                items: []
            },
            {
                id: 'dict-defined',
                label: $tr("userDefined", "User Defined"),
                icon: "books",
                open: false,
                modules: {MODULE_PLM},
                items: []
            },
            {
                id: 'dict-products',
                label: $tr("products", "Products"),
                icon: "books",
                modules: {MODULE_PLM},
                items: []
            },
            {
                id: 'dict-product-in-season',
                label: $tr("productInSeason", "Product in Season"),
                icon: "books",
                modules: {MODULE_PLM},
                items: []
            },
            {
                id: 'dict-product-in-season-colorbox',
                label: $tr("menuContent.productInSeason-Colorbox", "Product in Season - Colorbox"),
                icon: "books",
                modules: {MODULE_PLM},
                items: []
            },
            {
                id: 'dict-product-in-season-branding',
                label: $tr("menuContent.ProductInSeason-Branding", "Product in Season - Branding"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
            {
                id: 'dict-product-in-season-pp-samples',
                label: $tr("menuContent.Product.in.Season-PPSamples", "Product in Season - PP Samples"),
                icon: "books",
                modules: {MODULE_PLM},
                items: []
            },
            {
                id: 'dict-budgeting-planner-pm',
                label: $tr("menuContent.BudgetingPlanner M", "Budgeting Planner PM"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
            {
                id: 'dict-orders',
                label: $tr("orders", "Orders"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
            {
                id: 'dict-logistics',
                label: $tr("logistics", "Logistics"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
            {
                id: 'dict-suppliers',
                label: $tr("contractors", "Contractors"),
                icon: "books",
                modules: {MODULE_PLM, MODULE_LOGISTIC_OP},
                items: []
            },
            {
                id: 'dict-technological',
                label: $tr("technological", "Technological"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
            {
                id: 'dict-dimensions',
                label: $tr("productDimensions", "Product Dimensions"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
            {
                id: 'dict-calculations',
                label: $tr("calculations", "Calculations"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
            {
                id: 'dict-integration',
                label: $tr("Integration", "Integration"),
                modules: {MODULE_PLM},
                icon: "books",
                items: []
            },
        ]
    },
    {
        id: 'tools',
        devOnly: false,
        label: $tr("tools", "Tools"),
        icon: "fa-light fa-screwdriver-wrench",
        open: false,
        items: [
            {
                id: 'tools-pantone',
                label: $tr("pantone", "Pantone"),
                icon: "fa-thin fa-palette",
                action: async () => {
                    return ActivityManager.showActivity(PantoneActivity, {}, null, true);
                },
            },
            {
                id: 'ai-photo-generator',
                label: $tr("ai-photo-generator", "AI Photo Generator"),
                icon: "fa-regular fa-microchip-ai",
                enabledByFeatureFlag: FeatureFlag.AI_GENERATION_AND_VISUALIZATION,
                action: async () => {
                    return ActivityManager.showActivity(AIProductGenerator, {}, null, true);
                }
            },
            {
                id: 'translator',
                label: $tr("translator", "Translator"),
                icon: "language", //font awesome icon to choose same as on button
                action: async () => {
                    return DialogManager.translate('', 'en', 'en')
                },
            },
        ]
    },
    {
        id: 'int',
        label: $tr("integrations", "Integrations"),
        icon: "send-back",
        modules: {MODULE_PLM},
        open: false,
        items: [

            {
                id: 'i-import',
                label: $tr("manual.DataImport", "Manual Data Import"),
                modules: {MODULE_PLM},
                icon: "book-circle-arrow-up",
                action: async () => {
                    return ActivityManager.showActivity(DataImport, {}, null, true);
                },
                // action: async () => {
                //     await DialogManager.info("Not implemented", "Not implemented");
                // },
                permission: Perms.SUPERUSER
            },
            {
                id: 'a-swagger',
                label: $tr("apiPortal", "Api Portal"),
                icon: "webhook",
                action: async () => {
                    window.open(window["_apiEndpoint"] + "/dashboard/swagger-ui/", "silk-plm-swagger");
                },
                permission: null
            },
        ]
    },

    {
        id: 'adm',
        label: $tr("administration", "Administration"),
        icon: "user-tie-hair",
        items: [
            {
                id: 'adm-app',
                menuOrder: 250,
                label: $tr("application", "Application"),
                icon: "browser",
                items: [
                    {
                        id: 'company-configuration',
                        label: $tr("configuration", "Configuration"),
                        icon: "cog",
                        menuOrder: 300,
                        action: async () => {
                            let res = await listCompanyConfiguration();
                            if (res.length === 1) {
                                await Rpc.plm.services.CompanyConfigurationService.updateCompanyConfigurationFormAndFields().lock();
                                let configurationEntity = res[0];
                                return await FormsActions.editEntity(configurationEntity.__typename__, configurationEntity.id);
                            }
                        },
                        permission: Perms.ORGANIZATION_SETTINGS
                    },
                    // {
                    //     id: 'adm-printout',
                    //     label: $tr("menu-printout", "Printouts"),
                    //     icon: "print",
                    //     modules: {MODULE_PLM},
                    //     open: false,
                    //     items: []
                    // },
                ]
            },
            {
                id: 'GS1',
                label: $tr("GS1Configuration", "GS1 Configuration"),
                icon: "square-terminal",
                menuOrder: 210,
                action: async () => {
                    let res = await listGS1();
                    if (res.length === 1) {
                        let GS1Entity = res[0];
                        return await FormsActions.editEntity(GS1Entity.__typename__, GS1Entity.id);
                    }
                },
                enabledByFeatureFlag: FeatureFlag.GS1_INTEGRATION
            },
            {
                id: 'PrestaShop',
                label: $tr("PrestaShopConfiguration", "PrestaShop Configuration"),
                icon: "square-terminal",
                menuOrder: 220,
                action: async () => {
                    let res = await listPrestaShop();
                    if (res.length === 1) {
                        let PrestaShopEntity = res[0];
                        return await FormsActions.editEntity(PrestaShopEntity.__typename__, PrestaShopEntity.id);
                    }
                },
                enabledByFeatureFlag: FeatureFlag.PRESTASHOP_INTEGRATION
            },
            {
                id: 'organization',
                label: $tr("menuContent.system", "System"),
                icon: "building-ngo",
                menuOrder: 400,
                action: async () => {
                    return ActivityManager.showActivity(OrganizationSetup, {}, null, true);
                },
                permission: Perms.ORGANIZATION_SETTINGS
            },
            {
                id: 'subscription',
                label: $tr("menuContent.subscription", "Subscriptions"),
                icon: "money-check-dollar",
                menuOrder: 450,
                action: async () => {
                    openSubscriptionPanel();
                },
                permission: Perms.ORGANIZATION_SETTINGS,
                onlyForOrganizationSubscription: 'open'
            },
        ]
    },
    {
        id: 'acc',
        label: $tr("myAccount", "My account"),
        icon: "user-alt",
        items: [
            {
                onlyForOrganizationSubscription: 'open',
                onlyForSubscriptionType: 'free',

                id: 'upgrade',
                menuOrder: 90,
                label: $tr("upgrade", "Upgrade"),
                icon: "cart-circle-arrow-up",
                action: async () => {
                    EventBus.$emit(Events.showBuyPlanPopup, {popupStyle: 'upgrade', popupCanClose: true});
                },

                permission: null
            },
            {
                id: 'notifications',
                menuOrder: 100,
                label: $tr("notifications", "Notifications"),
                icon: "comment-alt-lines",
                action: async () => {
                    return ActivityManager.showActivity(UserNotificationsPanel, {}, null, true)
                },
                permission: null
            },
            {
                id: 'profile',
                label: $tr("myProfile", "My Profile"),
                menuOrder: 200,
                icon: "user-cog",
                action: async () => {
                    return ActivityManager.showActivity(UserEditPanel, {}, null, true)
                },
                permission: null
            },
            {
                id: 'edit-dashlets',
                label: $tr("customizeDashboard", "Customize Dashboard"),
                icon: "comment-alt-lines",
                menuOrder: 300,
                action: async () => {
                    return getDashletHome().toggleEdit();
                },
                enabledByFeatureFlag: FeatureFlag.DASHLETSCONFIGURATION,
                permission: null
            },
            {
                id: 'sign-out',
                label: $tr("signOut", "Sign Out"),
                icon: "power-off",
                menuOrder: 500,
                action: async () => {
                    return SessionManager.signOut()
                },
                permission: null
            }
        ]
    },

    {
        id: 'help',
        label: $tr("help", "Help"),
        icon: "handshake-angle",
        open: false,
        items: [

            {
                id: 'a-SupportSlack',
                label: $tr("support-slack", "Live chat on Slack"),
                icon: "comments",
                menuOrder: 100,
                action: async () => {
                    let url = await Rpc.Session.getSlackLink();
                    window.open(url, "_blank")
                },
                permission: null
            },

            {
                id: 'a-InstructionsAndSupport',
                label: $tr("InstructionsSupport", "Instructions and Support"),
                icon: "square-info",
                menuOrder: 100,
                action: async () => {
                    await ActivityManager.showActivity(InstructionsAndSupport, {}, null, true);
                },
                permission: null
            },
            {
                id: 'help-tours',
                label: $tr("menuContent.appTours", "Application tours"),
                icon: "building-ngo",
                menuOrder: 450,
                onlyForOrganizationSubscription: 'open',
                items: [
                    // {
                    //     id: 't-Inspirations',
                    //     label: $tr("tour.inspirations", "Inspirations and AI"),
                    //     icon: "square-info",
                    //     menuOrder: 100,
                    //     action: async () => {
                    //         window['Guides'].startInspirations();
                    //     },
                    //     permission: null
                    // },
                    {
                        id: 't-AddInspirations',
                        label: $tr("tour.addInspirations", "Add New Inspiration"),
                        icon: "square-info",
                        menuOrder: 110,
                        action: async () => {
                            window['Guides'].addInspiration();
                        },
                        enabledByFeatureFlag: FeatureFlag.AI_GENERATION_AND_VISUALIZATION,
                        permission: null
                    },
                    {
                        id: 't-Manage',
                        label: $tr("tour.manageSubscription", "Manage Your Subscription"),
                        icon: "square-info",
                        menuOrder: 120,
                        action: async () => {
                            window['Guides'].manageSubscription();
                        },
                        permission: null
                    },
                    {
                        id: 't-InPaint',
                        label: $tr("tour.AIInpaintTutorial", "AI Retouch tutorial"),
                        icon: "square-info",
                        menuOrder: 130,
                        action: async () => {
                            window['Guides'].AIInpaintTutorial();
                        },
                        enabledByFeatureFlag: FeatureFlag.AI_GENERATION_AND_VISUALIZATION,
                        permission: null
                    },
                    ]
            },
            // !!!! Wyłączamy bugzille

            // {
            //     id: 'a-bug',
            //     label: $tr("reportABug", "Report a Bug"),
            //     menuOrder: 200,
            //     icon: "user-headset",
            //     action: async () => {
            //         const token = await Rpc.Session.getBugzillaToken();
            //         if (!token) {
            //             await DialogManager.info(tr("coEmailSet", "No email set"),
            //                 $tr("menuContent.need.to.valid.email",
            //                     "To be able to file a bug you need to have a valid email set in your account profile"));
            //             return
            //         }
            //         window.open("https://silkplm.com/bugzilla/enter_bug.cgi?plm-token=" + token, "silk-plm-bugzilla");
            //     },
            //     permission: null,
            //     onlyForOrganizationSubscription: 'enterprise'
            // },
            // {
            //     id: 'a-ticket',
            //     label: $tr("myTickets", "My Tickets"),
            //     menuOrder: 300,
            //     icon: "tickets",
            //     action: async () => {
            //         const token = await Rpc.Session.getBugzillaToken();
            //         if (!token) {
            //             await DialogManager.info(tr("noEmailSet", "noEmailSet"),
            //                 $tr("menuContent.able.to.file.bug.need.have.valid.email.account",
            //                     "To be able to file a bug you need to have a valid email set in your account profile"));
            //             return
            //         }
            //         window.open("https://silkplm.com/bugzilla/buglist.cgi?component=SilkPLM%20Web%20Application&product=Silk%20PLM&plm-token=" + token, "silk-plm-bugzilla");
            //     },
            //     permission: null,
            //     onlyForOrganizationSubscription: 'enterprise'
            // },
        ]
    },
    {
        id: 'forms-tests',
        devOnly: true,
        label: 'Auto forms tests',
        icon: "pencil-alt",
        open: false,
        items: [
            {
                id: 'form-test-dictionary',
                label: 'Dictionary',
                icon: "books",
                open: false,
                items: []
            },
            {
                id: 'sale',
                label: "Multiselect",
                icon: "ballot-check",
                action: async () => {
                    console.log("Testing multiselect");
                    let action = await FormsActions.showMultiSelectList(BookHealthcheck);
                    let res = await action.getResult();
                    console.log(res);
                },
                permission: null
            },
        ]
    },
];

export class MenuItem {
    constructor() {
        this.id = "";
        this.label = "";
        this.icon = [];
        /** @type {Function}  */
        this.action = null;
        /** @type {String}  */
        this.permission = null;
        this.hasPermission = true;
        this.onlyForOrganizationSubscription = null;
    }
}

export class MenuSection {
    constructor() {
        this.id = "";
        this.accordionId = "";
        this.label = "";
        this.icon = [];
        this.open = false;

        /** @type {MenuItem[]} */
        this.items = [];
        this.hasAccessibleItems = true;
        this.onlyForOrganizationSubscription = null;
    }

    refreshPermissions() {
        let hasAccessibleItems = false;
        this.items.forEach(item => {
            item.hasPermission = (item.permission == null || SessionManager.hasPermission(item.permission));
            hasAccessibleItems = hasAccessibleItems || item.hasPermission;
        });
        this.hasAccessibleItems = hasAccessibleItems;
    }
}

export class SubMenu {
    constructor() {
        this.id = "";
        this.accordionId = "";
        this.label = "";
        this.icon = [];

        /** @type {MenuItem[]} */
        this.items = [];
        this.hasAccessibleItems = true;
        this.onlyForOrganizationSubscription = null;
    }

    refreshPermissions() {
        let hasAccessibleItems = false;
        this.items.forEach(item => {
            item.hasPermission = (item.permission == null || SessionManager.hasPermission(item.permission));
            hasAccessibleItems = hasAccessibleItems || item.hasPermission;
        });
        this.hasAccessibleItems = hasAccessibleItems;
    }
}

export class Menu {
    constructor() {
        /** @type {MenuSection[]} */
        this.sections = [];
        EventBus.$on(Events.permissionsChanged, () => this.refreshPermissions());
    }

    refreshPermissions() {
        setTimeout(() => {
            console.log("Menu - loading permissions");
            this.sections.forEach(value => {
                value.refreshPermissions();
            })
        });
    }
}

function scanSection(section, sectionById) {
    section.items.forEach(item => {
        if (item.items) {
            sectionById.set(item.id, item);
            scanSection(item, sectionById);
        }
    });
    section.items = section.items.filter(item => !item.isForm);
}


let firstLoad = true;

/**
 * @returns {Menu}
 */
export async function getLeftMenu(openedItem) {
    if (!CompanyConfigurationFormsLoader.getConfig()) {
        await CompanyConfigurationsFormsLoader.load();
    }

    let allForms = await FormsLoader.load(!firstLoad);
    firstLoad = false;
    let forms = [];
    allForms.forEach(form => {
        let enabledFormBySettings = checkIfEnabledByOrganizationFormsSettingsForForm(form.formId);
        if (!enabledFormBySettings) {
            return;
        }
        if (form.effectivePermissionRead && !form.isView) {
            let hasReadAccess = SessionManager.hasPermission(form.effectivePermissionRead);
            if (!hasReadAccess) {
                return;
            }
        }

        if (!form?.enabledByFeatureFlags || form.enabledByFeatureFlags.length === 0) {
            forms.push(form);
            return;
        }
        let enabledForm = checkIfEnabledByFeatureFlags(form.enabledByFeatureFlags);
        if (enabledForm) {
            forms.push(form);
        }
    });

    let sectionById = new Map();
    let leftMenu = LEFT_MENU();
    leftMenu.forEach(section => {
        section.open = openSection(section, openedItem);
        sectionById.set(section.id, section);
        scanSection(section, sectionById);
    });


    forms.sort((a, b) => {
        if (a.menuOrder === b.menuOrder) {
            return a.formTitle.localeCompare(b.formTitle);
        }
        if (a.menuOrder < b.menuOrder) {
            return -1;
        }
        return 1;
    })

    let i = 0;
    let sectionsToOrder = new Set();
    forms.forEach(form => {
        i++;
        if (form.menuGroup === null || form.menuGroup === undefined) {
            return;
        }
        if (!sectionById.has(form.menuGroup)) {
            Log.fatal("Menu group not found: " + form.menuGroup + " invalid form id:" + form.formId + " " + (form.formClass ?? form.formCode));
            return;
        }
        let section = sectionById.get(form.menuGroup);
        let formId = "form-" + (form.formClass ?? form.formCode);
        if (form.formIsView) {
            formId += "-" + form.viewName;
        }
        sectionsToOrder.add(form.menuGroup);

        let alternativeMenuLabel = findFieldValueFromCompanyCompanyConfigurationForm(form.formId, "alternativeMenuLabel");

        section.items.push({
            id: formId,
            label: alternativeMenuLabel || form.menuLabel,
            icon: form.icon,
            isForm: true,
            menuOrder: form.menuOrder,
            action: async () => {
                return FormsLoader.replaceFormActivityList(form.formId);
            },
            permission: form.restrictedList ? Perms["FORM_LIST_" + form.formId] : null
        });
    });

    sectionsToOrder.forEach(menuGroup => {
        let section = sectionById.get(menuGroup);
        section.items.sort((a, b) => {
            if (!a.menuOrder) {
                a.menuOrder = -1;
            }
            if (!b.menuOrder) {
                b.menuOrder = -1;
            }
            if (a.menuOrder === b.menuOrder) {
                return a.formTitle === b.formTitle ? 0 : a < b ? -1 : 1;
                // return 0;
            }
            if (a.menuOrder < b.menuOrder) {
                return -1;
            }
            return 1;
        });
    });

    let section = sectionById.get("plm");
    let brandingParameters = section.items.filter(obj => obj.id === "form-BrandingParameters");
    if (brandingParameters[0]) {
        brandingParameters[0].icon = "code-branch"
        brandingParameters[0].permission = Perms.BRANDING_PARAMETERS
        brandingParameters[0].action = async () => {
            await ActivityManager.showActivity(BrandingParameters, {}, null, true);
        }
    }

    let assignProductsToSeason = section.items.filter(obj => obj.id === "form-AssignProductsToSeason");
    if (assignProductsToSeason[0]) {
        assignProductsToSeason[0].icon = "pen-to-square"
        assignProductsToSeason[0].formOrder = 140
        assignProductsToSeason[0].enabledByFeatureFlag = FeatureFlag.SEPARATE_PRODUCT
        assignProductsToSeason[0].permission = Perms.ASSIGN_PRODUCTS_TO_SEASON
        assignProductsToSeason[0].action = async () => {
            await assignProducts();
        }
    }

    let reports = await Rpc.Reports.getReportConfigs();
    setDynamicPermissionsForReports(reports);
    reports = reports.filter(report => {
        let securityCode = report.securityCode;
        return SessionManager.hasPermission(securityCode) || SessionManager.hasPermission(Perms.ALL_REPORT);
    });

    let extendedMenu = [];
    leftMenu = removeLeftMenuItemsWhenHasNoItems(forms, leftMenu);
    leftMenu.forEach(section => {
        extendedMenu.push(section);
    });


    for (let menu of extendedMenu) {
        if (reports.length <= 0) {
            menu.items = menu.items.filter(item => item.id !== "reportsTab");
        }
    }

    let formConfig = FormsLoader.detectFormConfig(Inspiration.getRemoteClass());
    let formId = formConfig.formId;
    let active = EntityEditFormService.checkIfEnabledByOrganizationFormsSettingsForForm(formId);
    if(!active) {
        extendedMenu = extendedMenu.map(menu => ({
            ...menu,
            items: menu.items
                ? menu.items
                    .map(item => ({
                        ...item,
                        items: item.items
                            ? item.items
                                .map(subItem => ({
                                    ...subItem,
                                    items: subItem.items
                                        ? subItem.items.filter(innerItem => (innerItem.id !== "t-AddInspirations"))
                                        : undefined
                                }))
                                .filter(subItem => (subItem.id !== "t-AddInspirations"))
                            : undefined
                    }))
                    .filter(item => (item.id !== "t-AddInspirations"))
                : undefined
        }));
    }

    return getMenu(extendedMenu);
}

export function openSection(section, openedItem) {
    if (section.id === openedItem) {
        return true;
    }
}

function constructSubMenu(sectionDef) {
    let menuSection = new SubMenu();

    menuSection.id = sectionDef.id;
    menuSection.label = sectionDef.label;
    menuSection.icon = parseIconName(sectionDef.icon);
    menuSection.accordionId = "acc-" + menuSection.id;
    menuSection.open = sectionDef.open;
    menuSection.permission = sectionDef.permission;
    menuSection.hasPermission = (sectionDef.permission == null || SessionManager.hasPermission(sectionDef.permission));
    if(menuSection.onlyForOrganizationSubscription){

    }

    processSectionOrSubMenuItems(sectionDef, menuSection);

    return menuSection;
}

function processSectionOrSubMenuItems(sectionDef, targetMenuSection) {
    let items = sectionDef.items;
    for (let j in items) {
        let menuItemDef = items[j];
        if (menuItemDef?.devOnly && SessionManager.isProd()) {
            continue;
        }
        if(menuItemDef?.onlyForSubscriptionType){
            if(menuItemDef?.onlyForSubscriptionType !== SessionManager.userSubscriptionType){
                continue
            }
        }
        if(menuItemDef?.onlyForOrganizationSubscription){
            if(menuItemDef?.onlyForOrganizationSubscription !== SessionManager.organizationSubscriptionType){
                continue
            }
        }
        if (menuItemDef?.enabledByFeatureFlag) {
            if (!SessionManager.hasFlag(menuItemDef.enabledByFeatureFlag)) {
                continue;
            }
        }
        if (menuItemDef?.modules) {
            if (!SessionManager.anyModuleEnabled(menuItemDef?.modules)) {
                continue;
            }
        }

        if (sectionDef?.featureFlag) {
            if (!SessionManager.hasFlag(sectionDef.featureFlag)) {
                continue;
            }
        }

        if (menuItemDef.items) {
            let menuItem = constructSubMenu(menuItemDef);
            targetMenuSection.items.push(menuItem);
            targetMenuSection.hasAccessibleItems = targetMenuSection.hasAccessibleItems || menuItem.hasPermission;
            continue;
        }
        let menuItem = constructMenuItem(menuItemDef, sectionDef);
        targetMenuSection.hasAccessibleItems = targetMenuSection.hasAccessibleItems || menuItem.hasPermission;
        targetMenuSection.items.push(menuItem);
    }
}

function constructMenuItem(menuItemDef, sectionDef) {
    let menuItem = new MenuItem();

    menuItem.id = sectionDef.id + "-" + menuItemDef.id;
    menuItem.label = menuItemDef.label;
    menuItem.icon = parseIconName(menuItemDef.icon);
    menuItem.action = menuItemDef.action;
    menuItem.permission = menuItemDef.permission;
    menuItem.hasPermission = (menuItem.permission == null || SessionManager.hasPermission(menuItem.permission));

    return menuItem;
}

/**
 * @returns {Menu}
 */
export function getMenu(template) {
    let menu = new Menu();

    for (let i in template) {
        let sectionDef = template[i];
        if (sectionDef?.devOnly && SessionManager.isProd()) {
            continue;
        }
        if (sectionDef?.enabledByFeatureFlag) {
            if (!SessionManager.hasFlag(sectionDef.enabledByFeatureFlag)) {
                continue;
            }
        }
        if (sectionDef?.modules) {
            if (!SessionManager.anyModuleEnabled(sectionDef?.modules)) {
                continue;
            }
        }

        let menuSection = new MenuSection();
        menu.sections.push(menuSection);

        menuSection.id = "m-" + sectionDef.id;
        menuSection.accordionId = "acc-" + menuSection.id;
        menuSection.label = sectionDef.label;
        menuSection.icon = parseIconName(sectionDef.icon);
        menuSection.items = [];
        menuSection.open = sectionDef.open;
        menuSection.hasAccessibleItems = false;


        processSectionOrSubMenuItems(sectionDef, menuSection);
    }

    return menu;
}